import { FC } from 'react';

import cn from 'classnames';

import s from './AllAdvertisementSkeleton.module.scss';

export const AllAdvertisementSkeleton: FC = () => {
  return (
    <div className={s.container}>
      <div className={s.image}>
        <div className={s.label}></div>
      </div>
      <div className={s.bottom}>
        <span className={cn(s.text, s.one)}></span>
        <span className={cn(s.text, s.two)}></span>
        <span className={cn(s.text, s.three)}></span>
      </div>
    </div>
  );
};
